import script from "./OverlayLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverlayLoading.vue?vue&type=script&setup=true&lang=ts"

import "./OverlayLoading.vue?vue&type=style&index=0&id=0f5acebe&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5acebe"]])

export default __exports__